import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class SegmentInsertService {
	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }
	insertSegment(token, segment: any) {

		return this.http
			.post(this.apiUrl + "segments/v1/insertsegmento", segment, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/segments/service/segment-insert/segment-insert.service.ts